import {Utility} from "./Utility";
import {AttributeDescriptor, BaseModelDescriptor} from "../models/BaseModel";
import {EMPTY_PASSWORD} from "../models/User";
import {t} from "./localization";
import {type} from "os";

export const enum ValidationTypes {

	REQUIRED,
	EMAIL,
	NUMERIC,
	PASSWORD,
	PHONE,
	VAT_ID,
	COMPANY_ID,
	PERSONAL_ID
}

export class Validator {

	static validateItem (item: any, descriptor: BaseModelDescriptor) {
		let valid: boolean = true
		Object.keys(descriptor).forEach(function(key: string, value) {
			let attributeDescriptor: AttributeDescriptor = (descriptor as any)[key]
			valid = valid && Validator.validateAttribute(item[key], attributeDescriptor)
		});
		return valid
	}

	static validateAttribute (value: any, attributeDescriptor: AttributeDescriptor ): boolean {
		return Validator.validate(value, attributeDescriptor.validation)
	}

	static validate (value: any, types: ValidationTypes[]): boolean {

		let validOverall: boolean = true
		for (let type of types) {
			let valid: boolean = Validator.validateForType(value, type)
			validOverall = valid && validOverall
		}

		return validOverall
	}

	static validateForType (value: any, type: ValidationTypes): boolean {
		switch (type) {
			case ValidationTypes.REQUIRED:
				return Validator.isNotEmpty(value)
			case ValidationTypes.EMAIL:
				return Validator.isEmail(value)
			case ValidationTypes.NUMERIC:
				return Validator.isNumeric(value)
			case ValidationTypes.PASSWORD:
				return Validator.isValidPassword(value)
			case ValidationTypes.PHONE:
				return Validator.isPhone(value)
		}
	}

	static validateItemWithErrorTypes (item: any, descriptor: BaseModelDescriptor) {

		let valid: boolean = true;
		let invalidFields: any[] = [];

		Object.keys(descriptor).forEach(function(key: string, value) {

			let attributeDescriptor: AttributeDescriptor = (descriptor as any)[key]
			let validatedItem = Validator.validateByTypes(item, key, attributeDescriptor.validation)

			if(validatedItem.length) {
				invalidFields.push(validatedItem);
				valid = false;
			}
		});
		return { valid: valid, fields: invalidFields };
	}

	static validateByTypes (item: any, field: string, types: ValidationTypes[]): any[] {

		let value: string = item[field];
		let invalidTypes: any[] = [];

		for (let type of types) {
			let valid: any = Validator.validateForTypeResponse(field, value, type)

			if(!valid.valid) {
				invalidTypes.push(valid);
			}
		}
		return invalidTypes;
	}

	static validateForTypeResponse (field: string, value: any, type: ValidationTypes): object {

		let validated: { field: string, valid: boolean, message: string } = { field: field, valid: true, message: 'Ok' };

		switch (type) {
			case ValidationTypes.REQUIRED:
				if(!Validator.isNotEmpty(value)) {
					validated.valid = false;
					validated.message = t.RequiredField;
				}
				break;
			case ValidationTypes.EMAIL:
				if(!Validator.isEmail(value)) {
					validated.valid = false;
					validated.message = t.InvalidEmailAddress;
				}
				break;
			case ValidationTypes.NUMERIC:
				if(!Validator.isNumeric(value)) {
					validated.valid = false;
					validated.message = t.OnlyNumbersAllowed;
				}
				break;
			case ValidationTypes.PASSWORD:
				if(!Validator.isNotEmpty(value)) {
					validated.valid = false;
					validated.message = t.InvalidPassword;
				}
				break;
			case ValidationTypes.PHONE:
				if(!Validator.isPhone(value)) {
					validated.valid = false;
					validated.message = t.InvalidPhoneNumber;
				}
				break;
			case ValidationTypes.VAT_ID:
				if(!Validator.isVatId(value)) {
					validated.valid = false;
					validated.message = t.VatIdLengthWarning;
				}
				break;
			case ValidationTypes.COMPANY_ID:
				if(!Validator.isCompanyId(value)) {
					validated.valid = false;
					validated.message = t.CompanyIdLengthWarning;
				}
				break;
			case ValidationTypes.PERSONAL_ID:
				if (Utility.isNullOrUndefined(value)){
					validated.valid = false;
					validated.message = t.PersonalIdLengthWarning;
				} else {
					const errCode = Utility.validatePersonalId(value)
					if(errCode){
						validated.valid = false;
						switch(errCode) {
							case 1: 
								validated.message = t.PersonalIdLengthWarning;
								break;
							case 2: 
								validated.message = t.PersonalIdDateWarning;
								break;
							case 3: 
								validated.message = t.PersonalIdYearWarning;
								break;
							case 4: 
								validated.message = t.PersonalIdMonthWarning;
								break;
							case 5: 
								validated.message = t.PersonalIdDayWarning;
								break;
							case 6: 
							case 7:			
								validated.message = t.PersonalIdWrongWarning;
								break;
						}
					}
				}
				break;
		}
		return validated
	}

	static isNotEmpty (value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		if (typeof (value) == "string" && value == '') return false
		return true
	}

	static isEmail (value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		return Utility.validateEmail(value)
	}

	static isNumeric (value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		return Utility.isNum(value)
	}

	static isValidPassword (value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		if (value == EMPTY_PASSWORD) return false
		return true
	}

	static isPhone (value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		return Utility.validatePhone(value);
	}

	static isVatId(value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		return Utility.validateStringLength(value, 9);
	}

	static isCompanyId(value: any): boolean {
		if (Utility.isNullOrUndefined(value)) return false
		return Utility.validateStringLength(value, 8);
	}

	static displayFormErrors(fields: any, field: string): any {

		let error: any = { show: false, message: '' };

		if(fields.length) {
			fields.map((fieldArr: any[]) => {

				if(fieldArr[0].field === field) {
					error.show = true;
					error.message = fieldArr[0].message;
				}
			});
		}

		return error;
	}
}
